import { useCallback, useContext } from 'react';
import { ChannelContext, OrganisationContext } from '../../context';
import { StorySection } from '../../services';

export const usePinnedStoryId = () => {
  const { pinnedStoryId, pinnedStoryId2, pinnedStoryId3, pinnedStoryId4, pinnedStoryId5 } =
    useContext(ChannelContext).channel;

  const { pinnedStoryId: organisationPinnedStoryId } = useContext(OrganisationContext).organisation;

  const getPinnedStoryId = useCallback(
    (section?: StorySection) => {
      const pinnedStoryIdBySection: Partial<Record<StorySection, number>> = {
        [StorySection.PINNED]: pinnedStoryId,
        [StorySection.PINNED_2]: pinnedStoryId2,
        [StorySection.PINNED_3]: pinnedStoryId3,
        [StorySection.PINNED_4]: pinnedStoryId4,
        [StorySection.PINNED_5]: pinnedStoryId5,
        [StorySection.PINNED_ORG]: organisationPinnedStoryId,
      };

      const storyId = section ? pinnedStoryIdBySection[section] : undefined;

      if (!storyId || storyId < 0) {
        return undefined;
      }

      return storyId;
    },
    [
      organisationPinnedStoryId,
      pinnedStoryId,
      pinnedStoryId2,
      pinnedStoryId3,
      pinnedStoryId4,
      pinnedStoryId5,
    ]
  );

  return { getPinnedStoryId };
};
